import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=05ea16b8"
import script from "./ProjectIndex.vue?vue&type=script&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports